export default __webpack_public_path__ + "static/media/wmlWebsite3.22a8a15b.png";